import { render, staticRenderFns } from "./CInputList.vue?vue&type=template&id=3184986f&scoped=true&"
import script from "./CInputList.vue?vue&type=script&lang=js&"
export * from "./CInputList.vue?vue&type=script&lang=js&"
import style0 from "./CInputList.vue?vue&type=style&index=0&id=3184986f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184986f",
  null
  
)

export default component.exports